import axios from "axios";
import authHeader from "./auth-header";
import AuthService from "./auth.service";
import { config } from "../config";

class ServiceOrders {
  getLgServiceOrdersToAPI() {
    return axios
      .get(`${config["apiUrl"]}serviceOrders/lg`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }
  getLgServiceOrdersAccepted(params = {}) {
    return axios
      .get(`${config["apiUrl"]}serviceOrders/lg/list/accepted`, {
        headers: authHeader(),
        params: params,
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  countLgServiceOrdersAccepted() {
    return axios
      .get(`${config["apiUrl"]}serviceOrders/lg/list/accepted/count`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getLgServiceOrdersToAccept(params = {}) {
    return axios
      .get(`${config["apiUrl"]}serviceOrders/lg/list/toAccept`, {
        headers: authHeader(),
        params: params,
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  countLgServiceOrdersToAccept() {
    return axios
      .get(`${config["apiUrl"]}serviceOrders/lg/list/toAccept/count`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getLgServiceOrdersWithoutPat(params = {}) {
    return axios
      .get(`${config["apiUrl"]}serviceOrders/lg/list/withoutPat`, {
        headers: authHeader(),
        params: params,
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  countLgServiceOrdersWithoutPat() {
    return axios
      .get(`${config["apiUrl"]}serviceOrders/lg/list/withoutPat/count`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  createPatAcceptService(serviceOrderId) {
    return axios
      .patch(
        `${config["apiUrl"]}serviceOrders/lg/${serviceOrderId}/createPatAcceptService`,
        {},
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return error.response.data;
      });
  }

  getHisenseServiceOrdersToAPI() {
    return axios
      .get(`${config["apiUrl"]}serviceOrders/hisense`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getHisenseServiceOrdersAccepted(params = {}) {
    return axios
      .get(`${config["apiUrl"]}serviceOrders/hisense/list/accepted`, {
        headers: authHeader(),
        params: params,
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getHisenseServiceOrdersForAccepted(params = {}) {
    return axios
      .get(`${config["apiUrl"]}serviceOrders/hisense/list/forAccepted`, {
        headers: authHeader(),
        params: params,
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  countHisenseServiceOrdersAccepted() {
    return axios
      .get(`${config["apiUrl"]}serviceOrders/hisense/list/accepted/count`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  countHisenseServiceOrdersForAccepted() {
    return axios
      .get(`${config["apiUrl"]}serviceOrders/hisense/list/forAccepted/count`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getHisenseServiceOrdersWithoutPat(params = {}) {
    return axios
      .get(`${config["apiUrl"]}serviceOrders/hisense/list/withoutPat`, {
        headers: authHeader(),
        params: params,
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  countHisenseServiceOrdersWithoutPat() {
    return axios
      .get(`${config["apiUrl"]}serviceOrders/hisense/list/withoutPat/count`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  serviceOrderHisenseCreatePat(serviceOrderId) {
    return axios
      .patch(
        `${config["apiUrl"]}serviceOrders/hisense/${serviceOrderId}/createPat`,
        {},
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return error.response.data;
      });
  }

  createServiceOrderFromPat(pat, params) {
    return axios
      .post(
        `${config["apiUrl"]}serviceOrders/lg/createFromPat/${pat}`,
        params,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return error.response.data;
      });
  }

  getServiceOrderCodes(code) {
    return axios
      .get(`${config["apiUrl"]}serviceOrders/lg/code/${code}`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  /**
   * Extranet Service Orders
   */
  countExtranetServiceAccepted() {
    return axios
      .get(`${config["apiUrl"]}serviceOrders/extranet/accepted/count`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  countExtranetServiceWithoutPat() {
    return axios
      .get(`${config["apiUrl"]}serviceOrders/extranet/withoutPat/count`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }
  getExtranetServiceAccepted(params = {}) {
    return axios
      .get(`${config["apiUrl"]}serviceOrders/extranet/accepted`, {
        headers: authHeader(),
        params: params,
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getExtranetServiceWithoutPat(params = {}) {
    return axios
      .get(`${config["apiUrl"]}serviceOrders/extranet/withoutPat`, {
        headers: authHeader(),
        params: params,
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  serviceOrderExtranetCreatePat(id) {
    return axios
      .patch(`${config["apiUrl"]}serviceOrders/extranet/${id}/createPat`, {}, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 201) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getServiceOrderByBrandAndPat(patId) {
    if (!patId) {
      return Promise.resolve(null);
    }

    return axios
      .get(`${config["apiUrl"]}serviceOrders/check/pat/${patId}`, {
        headers: authHeader(),
      })
      .then((response) => (response.status === 200 ? response.data : null))
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          AuthService.logout();
          window.location = "/login";
        }
        if (error.response && error.response.status === 404) {
          return null;
        }
        if (!error.response) {
          console.log("ERROR:: ", error);
        }
        return null;
      });
  }

  getDgServiceOrdersToAPI() {
    return axios
      .get(`${config["apiUrl"]}serviceOrders/dg`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getDgServiceOrdersAccepted(params = {}) {
    return axios
      .get(`${config["apiUrl"]}serviceOrders/dg/list/accepted`, {
        headers: authHeader(),
        params: params,
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  countDgServiceOrdersAccepted() {
    return axios
      .get(`${config["apiUrl"]}serviceOrders/dg/list/accepted/count`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getDgServiceOrdersWithoutPat(params = {}) {
    return axios
      .get(`${config["apiUrl"]}serviceOrders/dg/list/withoutPat`, {
        headers: authHeader(),
        params: params,
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  countDgServiceOrdersWithoutPat() {
    return axios
      .get(`${config["apiUrl"]}serviceOrders/dg/list/withoutPat/count`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  serviceOrderDgCreatePat(serviceOrderId) {
    return axios
      .patch(
        `${config["apiUrl"]}serviceOrders/dg/${serviceOrderId}/createPat`,
        {},
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return error.response.data;
      });
  }
}
export default new ServiceOrders();
